
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: any[]) => {},
  error: (...args: any[]) => isDev && console.error(...args),
  warn: (...args: any[]) => {},
  info: (...args: any[]) => {},
};

// Export a safe logger that never logs sensitive data
export const safeLogger = {
  log: (message: string) => {},
  error: (message: string) => isDev && console.error(`[ERROR] ${message}`),
  warn: (message: string) => {},
  info: (message: string) => {},
};
